import React from 'react'
import JoinButtons from './JoinButtons.js'
import './FooterHeader.css'

function FooterHeader() {
  return (
	<div className='footer-header'>
		<h2>Join us</h2>
		<JoinButtons />
	</div>
  )
}

export default FooterHeader